<template>
  <template v-for="row in rows" :key="row">
    <template v-for="column in columns" :key="column">
      <SfSkeletonLoader class="tw-w-full tw-h-7" />
    </template>
  </template>
</template>
<script lang="ts" setup>
import SfSkeletonLoader from '@app/shared/vue/components/sf-skeleton-loader.vue'

interface Props {
  columns: number
  rows: number
}

defineProps<Props>()
</script>
